import React from 'react';
import PropTypes from 'prop-types';

const defaultClass = 'ncss-label';

const Label = ({ children, title, className, useBareClass, htmlFor, ...props }) => (
  <label {...props} htmlFor={htmlFor} className={`${useBareClass || defaultClass} ${className || ''}`}>
    {children}
  </label>
);

Label.defaultProps = {
  className: '',
  title: null,
  htmlFor: null,
  children: null,
  useBareClass: null
};

Label.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  className: PropTypes.string,
  useBareClass: PropTypes.string,
  htmlFor: PropTypes.string
};

export default Label;
